class blogPage {
  init() {
    if(window.innerWidth <= 767) {
      if($('.h5-links a').length>3) {
        var el = $('<a href="#contents" class="tog-contents mobonly"></a>');

        // initial active label
        var act = $('.h5-links a.act').text();
        var html = "<span>"+act+"<em>"+window.themeStrings.filter+"</em></span>";

        el.html(html);
        el.insertBefore('.h5-links');

        el.on('click', function(e) {
          e.preventDefault();

          $('.h5-links').slideToggle(300);

          $(this).toggleClass('on');

          // toggle text based on state, not text
          var tx = $(this).hasClass('on')
            ? window.themeStrings.close
            : window.themeStrings.filter;

          var act = $('.h5-links a.act').text();
          var html = "<span>"+act+"<em>"+tx+"</em></span>";

          $(this).html(html);
        });

        $('.h5-links').hide();
      }
    }
  }
} export default blogPage;
